// Any fixed origin works: a value is app-relative exactly when resolving it
// keeps it on whichever origin it was resolved against.
const PLACEHOLDER_ORIGIN = 'https://return-to.invalid';

// URL parsing silently strips tab, CR and LF and trims C0 controls and spaces,
// so '/\t/evil.example.com' passes a prefix check yet resolves off-site. A
// genuine path carries these percent-encoded, never raw.
const HIGHEST_CONTROL_OR_SPACE_CHAR_CODE = 0x20;
const DELETE_CHAR_CODE = 0x7f;

const hasControlOrSpaceCharacter = (value: string) =>
  Array.from(value).some((character) => {
    const charCode = character.charCodeAt(0);
    return (
      charCode <= HIGHEST_CONTROL_OR_SPACE_CHAR_CODE ||
      charCode === DELETE_CHAR_CODE
    );
  });

/**
 * True only for single-slash app-relative paths. Rejects protocol-relative
 * URLs ('//evil.example.com'), the backslash variant ('/\evil.example.com')
 * and anything else that resolves to another origin, so a returnTo can never
 * send the user off-site when used as a redirect target or href.
 */
export const isAppRelativeReturnTo = (
  value: string | undefined
): value is string => {
  if (typeof value !== 'string' || !value.startsWith('/')) return false;
  if (hasControlOrSpaceCharacter(value)) return false;

  try {
    return new URL(value, PLACEHOLDER_ORIGIN).origin === PLACEHOLDER_ORIGIN;
  } catch {
    return false;
  }
};
